// Module
var code = "<stuff-form :item=\"item\" type=\"add\"/> ";
// Exports
module.exports = code;